import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";

export interface PlaceState {
    placeIdHashList: string[];

    displayVacancyList: SignageAdapterApi.ResponseGetDisplayVacancy[];
    areaGenderList: [];
    fetchingPlaceTimer: NodeJS.Timer | undefined;
    fetchingVacancyTimer: NodeJS.Timer | undefined;
    intervalToFetchPlace: number;
    intervalToFetchVacancy: number;
    floorPlan: FloorCells[];
}

export interface GenderData {
    female: SignageAdapterApi.ResponseGetPlace | undefined;
    male: SignageAdapterApi.ResponseGetPlace | undefined;
    "barrier-free": SignageAdapterApi.ResponseGetPlace | undefined;
    spacious: SignageAdapterApi.ResponseGetPlace | undefined;
    nursing: SignageAdapterApi.ResponseGetPlace | undefined;
    baby: SignageAdapterApi.ResponseGetPlace | undefined;
}

export interface CellDataData {
    [key: string]: {}
}
export interface CellData {
    name: string;
    keys: string[];
    areaName: string[];
    data: CellDataData;
}

export interface FloorCells {
    title: string;
    cell: CellData[];
}

export const state: PlaceState = {
    placeIdHashList: [],
    displayVacancyList: [],
    areaGenderList: [],
    fetchingPlaceTimer: undefined,
    fetchingVacancyTimer: undefined,
    intervalToFetchPlace: 15 * 60 * 1000,
    intervalToFetchVacancy: 5 * 1000,
    floorPlan: [
        {
            title: "BLDG3 1F",
            cell: [
                {
                    name: "card1",
                    keys: ["ANABUKI-2F-7-W", "ANABUKI-2F-7-M"],
                    areaName: [
                        "あなぶき_2F_7個室",
                        "あなぶき_2F_7個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG5 1F",
            cell: [
                {
                    name: "card2",
                    keys: ["ANABUKI-2F-17-W", "ANABUKI-2F-17-M"],
                    areaName: [
                        "あなぶき_2F_17個室",
                        "あなぶき_2F_17個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG10 1F",
            cell: [
                {
                    name: "card3",
                    keys: ["ANABUKI-2F-22-W", "ANABUKI-2F-22-M"],
                    areaName: [
                        "あなぶき_2F_22個室",
                        "あなぶき_2F_22個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG12 1F",
            cell: [
                {
                    name: "card4",
                    keys: ["ANABUKI-1F-15-W", "ANABUKI-1F-15-M"],
                    areaName: [
                        "あなぶき_1F_15個室",
                        "あなぶき_1F_15個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG12 2F",
            cell: [
                {
                    name: "card5",
                    keys: ["ANABUKI-1F-14-W", "ANABUKI-1F-14-M"],
                    areaName: [
                        "あなぶき_1F_14個室",
                        "あなぶき_1F_14個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG17 1F",
            cell: [
                {
                    name: "card6",
                    keys: ["ANABUKI-1F-11-W", "ANABUKI-1F-11-M"],
                    areaName: [
                        "あなぶき_1F_11個室",
                        "あなぶき_1F_11個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
        {
            title: "BLDG18 1F",
            cell: [
                {
                    name: "card7",
                    keys: ["ANABUKI-1F-13-W", "ANABUKI-1F-13-M"],
                    areaName: [
                        "あなぶき_1F_13個室",
                        "あなぶき_1F_13個室_Mens",
                    ],
                    data: {},
                },
            ],
        },
    ] as FloorCells[],
};
